import { fromJS } from 'immutable'; // use of immutablejs for various js operations to simplify our work
import { setItem } from 'utils/localStorage';
import { getProfile, saveProfileVideo, removeVideoById } from 'services/saProfile.service';
import { CURRENT_VIDEO_URL } from 'containers/AthleteById/actionTypes';
import { updateProfilePicture } from './../../common/services/session.service';
import {
  REQUESTED,
  FAILED,
  SUCCESSFUL,
  SET_CURRENT_VIDEO,
  ADD_VIDEO_REQUESTED,
  ADD_VIDEO_SUCCESSFUL,
  ADD_VIDEO_FAILED,
  REMOVE_VIDEO_REQUESTED,
  REMOVE_VIDEO_FAILED,
  REMOVE_VIDEO_SUCCESSFUL,
} from './actionTypes';

export function getSAProfile(id) { // eslint-disable-line
  return (dispatch) => {
    dispatch({
      type: REQUESTED,
    });
    getProfile(id)
        .then((data) => {
          const temp = { ...data };
          if (data.profile_image !== undefined) {
            setItem('profile_image', data.profile_image);
          } else {
            setItem('profile_image', '');
          }
          if (data.payment_info !== undefined) {
            const lastItem = data.payment_info[data.payment_info.length - 1];
            window.sessionStorage.setItem('kiro', lastItem.payment_status);
          } else {
            window.sessionStorage.setItem('kiro', false);
          }
          if (!data.contactedCount) {
            temp.contactedCount = {
              count: 0,
              lastContacted: null,
            };
          }
          if (temp) {
            dispatch({
              type: SUCCESSFUL,
              profile: fromJS(temp),
            });
          }
        })
        .catch((err) => {
          dispatch({
            type: FAILED,
            error: err,
          });
        });
  };
}

export function videoDetails(video, cb) {
  return (dispatch) => {
    dispatch({
      type: ADD_VIDEO_REQUESTED,
    });
    saveProfileVideo(video)
          .then((data) => {
            dispatch({
              type: ADD_VIDEO_SUCCESSFUL,
              profile: fromJS(data),
            });
            if (cb) {
              cb(fromJS(data.video_items));
            }
          })
          .catch((err) => {
            dispatch({
              type: ADD_VIDEO_FAILED,
              error: err,
            });
          });
  };
}

export function saveUserImage(profileId, file) {
  return (dispatch) => {
    updateProfilePicture(profileId, file, (error, result) => {
      if (error) {
        dispatch({
          type: FAILED,
          profile: fromJS(result),
        });
      }
    });
  };
}

export function setCurrentVideo(data) {
  return (dispatch) => {
    dispatch({
      type: SET_CURRENT_VIDEO,
      url: data,
    });
    dispatch({
      type: CURRENT_VIDEO_URL,
      url: data,
    });
  };
}

export function removeVideo(data, cb) {
  return (dispatch) => {
    dispatch({
      type: REMOVE_VIDEO_REQUESTED,
    });
    removeVideoById(data)
      .then((response) => {
        dispatch({
          type: REMOVE_VIDEO_SUCCESSFUL,
          profile: fromJS(response),
        });
        cb();
      })
      .catch((err) => {
        dispatch({
          type: REMOVE_VIDEO_FAILED,
          error: err,
        });
      });
  };
}



// WEBPACK FOOTER //
// ./src/containers/Profile-view/actions.js